import each from 'lodash-es/each';
import closeAllMenus from '../../core/INF-closeAllMenus';
import positionModal from './positionModal';
import resetModal from './resetModal';
import openShoppableImage from './openShoppableImage';
import initSlider from './initSlider';

export default (target, img) => {
  const modal = document.querySelector('[data-shoppable-image-modal]');
  const shoppableImagesUrl = `/pages/shoppable-image/${new Date().getTime()}/?products=${
    target.dataset.shoppableImage
  }&cache=false`;
  fetch(shoppableImagesUrl)
    .then((response) => response.text())
    .then((html) => {
      const tempDiv = document.createElement('div');
      tempDiv.classList.add('Model-content-new');
      tempDiv.innerHTML = html;
      const products = tempDiv.querySelectorAll('[data-products-content] [data-shoppable-product]');

      if (products.length < 1) {
        closeAllMenus();
        return;
      }

      resetModal();

      const modalImage = modal.querySelector('[data-shoppable-modal-image]');
      const imgElement = document.createElement('img');
      imgElement.src = img.src;
      imgElement.alt = img.alt;

      modalImage.appendChild(imgElement);
      modalImage.dataset.accentColor = target.dataset.accentColor;

      each(products, (product) => {
        modal.querySelector('[data-shoppable-modal-products]').appendChild(product);
      });

      if (window.theme.breakpoints.current === 'mobile') {
        modalImage.style.backgroundColor = modalImage.dataset.accentColor;
      }

      // Need timeout for Flickity to correctly calculate viewport height
      setTimeout(() => {
        initSlider();
      }, 100);

      positionModal();
      openShoppableImage();
    });
};
